/* istanbul ignore file */
import { FormSection, FormRow } from 'framework/ui/layout';
import { useEffect } from 'react';
import { DateInput, NumberInput, TextArea, TextInput, useFormContext, ClearAfterUnmountWrapper } from 'framework/form';
import { useParams } from 'react-router-dom';
import { useDateService } from 'framework/utils';
import { BudgetInput } from 'domain/shared/budget';
import { NotDismissedEmployeeInput } from 'domain/shared/employee';

const BudgetForm = () => {
  const { id: budgetId } = useParams<Dictionary<string>>();
  const { data, onChangeCallback, setFieldErrors } = useFormContext();
  const { formatDateForAPI } = useDateService();
  const hasChildren = data?.childBudgets?.length;

  const isCommercialBudget = () => {
    return !!(data && data.parentId && data.parentName && data.parentName === 'Commercial efforts');
  };

  useEffect(() => {
    if (data && data.softPeriodTo) {
      if (onChangeCallback) {
        const periodToDate = new Date(data.softPeriodTo);
        periodToDate.setDate(periodToDate.getDate() + 14);
        const periodTo = formatDateForAPI(periodToDate.toDateString());
        if (setFieldErrors && (!data.periodFrom || (data.softPeriodTo && data.periodFrom <= data.softPeriodTo))) {
          setFieldErrors('softPeriodTo', []);
        }
        onChangeCallback(
          {
            softPeriodTo: data.softPeriodTo,
            periodTo,
          },
          false,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.softPeriodTo]);

  return (
    <FormSection title="Budget information">
      <FormRow>
        <TextInput source="name" />
        <NotDismissedEmployeeInput source="ownerId" label="Owner" nameSource="ownerName" />
      </FormRow>
      <FormRow>
        <BudgetInput
          mapResults={(budget: any) => {
            return {
              id: budget.id,
              text: budget.name,
              parentName: budget.name,
            };
          }}
          source="parentId"
          label="Parent budget"
          nameSource="parentName"
          searchString="name"
          filter={{ excludedId: budgetId, notArchived: true }}
        />
        <NumberInput source="maxFtePercent" label="Max FTE, people" isVisible={!hasChildren} />
      </FormRow>
      <FormRow>
        <DateInput source="periodFrom" label="Start date" isVisible={!hasChildren} />
        <DateInput source="periodTo" label="End Date" isVisible={!hasChildren} />
      </FormRow>
      <FormRow>
        <ClearAfterUnmountWrapper isVisible={isCommercialBudget() && !hasChildren}>
          <DateInput source="softPeriodFrom" label="Soft start date" />
        </ClearAfterUnmountWrapper>
        <ClearAfterUnmountWrapper isVisible={isCommercialBudget() && !hasChildren}>
          <DateInput source="softPeriodTo" label="Soft end date" />
        </ClearAfterUnmountWrapper>
      </FormRow>
      <FormRow colMd={8} colXl={6}>
        <TextArea source="purpose" label="Notes" />
      </FormRow>
    </FormSection>
  );
};

export default BudgetForm;
